import React from 'react';
import { Skeleton, Card } from 'antd';

const TableSkeleton: React.FC = () => {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <Skeleton.Button active size="default" style={{ width: 120 }} />
        <div style={{ display: 'flex', gap: 8 }}>
            <Skeleton.Button active size="default" />
            <Skeleton.Button active size="default" />
            <Skeleton.Button active size="default" />
        </div>
      </div>
      <Card bordered={false}>
        <Skeleton active paragraph={{ rows: 10 }} />
      </Card>
    </div>
  );
};

export default TableSkeleton;
